module.exports = __webpack_public_path__ + "img/joushinji_logo_white_separate_first.84564a62.png";